/**************************************************
 * Nombre:       Seccion_Videos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Usuario from "../Dialogos/Dialogo_Usuario";
import {theme} from "../../Tema";
import Tarjeta_Videos from "../Tarjetas/Tarjeta_Videos";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {useParams} from "react-router-dom";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";


const Seccion_Videos = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [videos, setVideos] = useState([]);
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Usuario,
        titulo: 'Detalles del usuario',
        //  realizado: cargarNuevamente
    })
    const [idEscogido, setIdEscogido] = useState('');


    useEffect(() => {

        obtenerCol('youtubes').then((dox) => {
            setVideos(dox.data);
        })

    }, [])

    useEffect(() => {

        if (parms && parms.id) {
            setIdEscogido(parms.id);
        }

    }, [parms]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
                onLoad={() => {

                    if (idEscogido) {
                        scrolearAComponente(idEscogido)
                    }

                }
                }
            >

                <Dialogo/>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 32 : 36,
                                        fontWeight: 800,
                                        lineHeight: 1.1
                                    }}>
                                        Videos de YouTube para compartir
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 2 : 0}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        Encuentra aquí videos pensados para inspirar, aprender y compartir con tu
                                        comunidad, ampliando el mensaje del Team Tufiño.
                                    </Typography>
                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 8, px: sCell ? 0 : 4}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={6}
                    >

                        {videos.map((it, index) => (
                            <Grid id={it.id} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Videos escogida={idEscogido}  item={it}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Videos


